/**
 * Pix's own brand colours for the mark.
 *
 * Deliberately NOT run through `themed()`, for the same reason as `SPEI_BRAND_*` in
 * [`spei.tokens.ts`](./spei.tokens.ts): these belong to a third-party payment rail, so they must
 * not be re-derived by our light/accent palette machinery the way our own tokens are. The rest of
 * the Pix screen (panel, steps, notice) re-uses the `SPEI` tokens rather than re-declaring them.
 *
 * The official teal is used in both studio themes (about 8:1 on the dark checkout pane). `ink` is
 * the brand's dark counterpart, for a surface that needs a mark-on-teal treatment.
 */
export const PIX_BRAND = {
  teal: '#32bcad',
  ink: '#0b0b0e',
} as const;
